import FieldsetContainer from 'components/blocks/Delta/Inputs/Containers/FieldsetContainer';
import AccordionForm from 'components/blocks/ManagementNewForms/Accordion/AccordionForm';
import FormDatosPersonales from 'components/blocks/ManagementNewForms/ButtonGroups/FormDatosPersonales';
import FormObservaciones from 'components/blocks/ManagementNewForms/Inputs/FormObservaciones';
import { useEffect, useState } from 'react'
import { FormProvider, set, useFieldArray, useForm } from 'react-hook-form';
import Loader from 'components/blocks/Loader/Loader';
import FormBotonSubmit from 'components/blocks/ManagementNewForms/Inputs/FormInputSubmit';
import useCreatePrestacionCUME from 'services/record/PrestacionCUME/useCreatePrestacionCUME';
import useUpdatePrestacionCUMEByID from 'services/record/PrestacionCUME/useUpdatePrestacionCUME';
import FormInputRadioGroup from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputRadioGroup';
import FormInputCheckboxTable from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputCheckBoxTable';
import FormInputEmail from 'components/blocks/ManagementNewForms/Inputs/FormInputEmail';
import FormInputText from 'components/blocks/ManagementNewForms/Inputs/FormInputTexto';
import FormInputYesNo from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputYesNo';
import AccordionDisplay from 'components/blocks/ManagementNewForms/Accordion/AccordionDisplay';
import FormInputFecha from 'components/blocks/ManagementNewForms/Inputs/FormInputFecha';
import InputTextIntegration from 'components/blocks/ManagementNewForms/Inputs/InputTextIntegration';
import TestCommunity from 'components/blocks/Delta/Inputs/TestCommunity';
import Province from 'components/blocks/Delta/Inputs/Province';
import TextAreaDefault from 'components/blocks/ManagementNewForms/TextArea/TextAreaDefault';
import FormInputCuentaBancaria from 'components/blocks/ManagementNewForms/Inputs/FormInputCuentaBancaria';
import FormInfoCreateUpdate from 'components/blocks/ManagementNewForms/Inputs/FormInfoCreateUpdate';
import FormArrayArchivosReducidos, { adaptDocumentacion, prepareDocumentacionArrayWithCase } from 'components/blocks/ManagementNewForms/ButtonGroups/ArrayInputArchivo';
import FormInputEnfermedadesCUME from 'components/blocks/ManagementNewForms/Inputs/FormInputEnfermedadesCUME';
import FormRelacionesLaborales, { normalizeRelacionLaboralBoolean } from 'components/blocks/ManagementNewForms/Inputs/FormRelacionesLaborales';

const PrestacionCUME = ({ info, dataUser, onSuccess }: { info: boolean; dataUser: any, onSuccess?: () => void }) => {


    const formMethods = useForm();
    const { register, handleSubmit, setError, formState: { errors }, setValue, watch, reset, control, getValues } = formMethods;
    const { createPrestacionCUME, dataCreatePrestacionCUME, errorCreatePrestacionCUME, loadingCreatePrestacionCUME, successCreatePrestacionCUME } = useCreatePrestacionCUME();
    const { dataUpdatePrestacionCUMEById, errorUpdatePrestacionCUMEById, loadingUpdatePrestacionCUMEById, successUpdatePrestacionCUMEById, updatePrestacionCUMEById } = useUpdatePrestacionCUMEByID();
    const [datosAPI, setDatosAPI] = useState(dataUser);
    const [bloquearEnvio, setBloquearEnvio] = useState<boolean>(false);
    const [loader, setLoader] = useState(false);

    const watchProvinciaCooperativa = watch("DomicilioComunicaciones.Provincia");
    const watchProvinciaDescCooperativa = watch("DomicilioComunicaciones.ProvinciaDescripcion");
    const watchCommCooperativa = watch("DomicilioComunicaciones.Localidad");
    const watchCommDescCooperativa = watch("DomicilioComunicaciones.LocalidadDescripcion");
    const getValue = (...values: any[]) => values.find(v => v !== undefined && v !== null);
    const [totalSize, setTotalSize] = useState(0);
    const MAX_SIZE_MB = 30;

    const toStringArray = (value: any): string[] => {
        if (Array.isArray(value)) {
            return value
                .map((item) => String(item ?? '').trim())
                .filter((item) => item !== '');
        }

        if (value === null || value === undefined || value === '') {
            return [];
        }

        const normalized = String(value).trim();
        return normalized ? [normalized] : [];
    };

    const adaptApiResponseToDefaultValues = (data: any) => {
        //console.log(data)
        if (data) {

            const datosPersonales = data?.datosPersonales || data?.DatosPersonales || {};
            const datosMenor = Array.isArray(data?.datosMenor)
                ? data.datosMenor
                : Array.isArray(data?.DatosMenor)
                    ? data.DatosMenor
                    : [];
            const menor1 = datosMenor[0] || {};
            const menor2 = datosMenor[1] || {};

            const getMenorNombre = (menor: any) =>
                menor?.nombreApellidos || menor?.NombreApellidos || menor?.menorNombre || menor?.MenorNombre || "";
            const getMenorIPF = (menor: any) =>
                menor?.ipf || menor?.IPF || menor?.menorIPF || menor?.MenorIPF || "";
            const getMenorFechaNacimiento = (menor: any) =>
                menor?.fechaNacimiento || menor?.FechaNacimiento || menor?.menorFechaNacimiento || menor?.MenorFechaNacimiento || "";

            reset({
                DatosPersonales: {
                    SolicitanteNombre: datosPersonales?.nombre || datosPersonales?.Nombre || "",
                    SolicitanteApellido1: datosPersonales?.apellido1 || datosPersonales?.Apellido1 || "",
                    SolicitanteApellido2: datosPersonales?.apellido2 || datosPersonales?.Apellido2 || "",
                    SolicitanteIPF: datosPersonales?.ipf || datosPersonales?.IPF || "",
                    SolicitanteIPFTipo: (datosPersonales?.ipfTipo ?? datosPersonales?.IPFTipo ?? 1).toString(),

                    SolicitanteTelefono: datosPersonales?.telefono || datosPersonales?.Telefono || "",
                    SolicitanteFijo: datosPersonales?.fijo || datosPersonales?.Fijo || "",
                    SolicitanteDomicilio: datosPersonales?.domicilio || datosPersonales?.Domicilio || "",
                    SolicitanteCodigoPostal: datosPersonales?.codigoPostal || datosPersonales?.CodigoPostal || "",
                    SolicitanteProvincia: datosPersonales?.CodigoProvincia || "",
                    SolicitanteProvinciaDescripcion: datosPersonales?.Provincia || "",
                    SolicitanteComunidadCodigo: datosPersonales?.CodigoLocalidad || "",
                    SolicitanteNumeroSS: datosPersonales?.numeroSeguridadSocial || datosPersonales?.NumeroSeguridadSocial || "",
                    SolicitanteFechaNacimiento: data?.fechaNacimiento || data?.FechaNacimiento || "",
                    CorreoElectronico: data?.email || data?.Email || "",
                    SolicitanteEmpresa: data?.empresaNombre || data?.EmpresaNombre || "",
                    SolicitanteCCC: data?.empresaCCC || data?.EmpresaCCC || "",
                    SolicitanteNAF: data?.empresaNAF || data?.EmpresaNAF || data?.NAF || data?.naf || "",
                    SolicitanteCIF: data?.empresaCIF || data?.EmpresaCIF || data?.CIF || data?.cif || "",
                    EsAutonomo: normalizeRelacionLaboralBoolean(data?.EsAutonomo ?? data?.esAutonomo),
                    RelacionConElMenor: data?.RelacionMenor?.toString() ?? null,
                    FamiliaMonoparental: data?.esFamiliaMonoparental ?? data?.EsFamiliaMonoparental ?? null,
                    SolicitanteNacionalidad: data?.Nacionalidad || data?.nacionalidad || "",
                },

                DatosOtroProgenitor: {
                    OtroProgenitorNombre: data?.otroProgenitor_Nombre || data?.OtroProgenitor_Nombre || "",
                    OtroProgenitorApellido1: data?.otroProgenitor_Apellido1 || data?.OtroProgenitor_Apellido1 || "",
                    OtroProgenitorApellido2: data?.otroProgenitor_Apellido2 || data?.OtroProgenitor_Apellido2 || "",
                    OtroProgenitorIPF: data?.otroProgenitor_IPF || data?.OtroProgenitor_IPF || "",
                    OtroProgenitorNumeroSS: data?.otroProgenitor_NumeroSeguridadSocial || data?.OtroProgenitor_NumeroSeguridadSocial || "",
                    TrabajaPorCuenta: data?.OtroProgenitor_TrabajoTipo?.toString() ?? null,
                    TipoRegimen: (data?.otroProgenitor_RegimenTipoActividad ?? data?.OtroProgenitor_RegimenTipoActividad ?? "")?.toString?.() ?? "",
                    Empresa: data?.otroProgenitor_EmpresaNombre || data?.OtroProgenitor_EmpresaNombre || "",
                    CCC: data?.otroProgenitor_EmpresaCCC || data?.OtroProgenitor_EmpresaCCC || "",
                    RegimenEspecial: data?.otroProgenitor_RegimenEspecialNombre || data?.OtroProgenitor_RegimenEspecialNombre || "",
                    OtroRegimen: data?.otroProgenitor_RegimenOtrosNombre || data?.OtroProgenitor_RegimenOtrosNombre || "",
                },

                DatosMenor: [
                    {
                        MenorNombre: getMenorNombre(menor1),
                        MenorIPF: getMenorIPF(menor1),
                        MenorFechaNacimiento: getMenorFechaNacimiento(menor1),
                    },
                    {
                        MenorNombre: getMenorNombre(menor2),
                        MenorIPF: getMenorIPF(menor2),
                        MenorFechaNacimiento: getMenorFechaNacimiento(menor2),
                    },
                ],

                MotivoSolicitud: {
                    FechaIngreso: data?.fechaIngresoMenor || data?.FechaIngresoMenor || "",
                    ReduccionJornada: data?.reducidaJornadaLaboral ?? data?.ReducidaJornadaLaboral ?? null,
                    FechaReduccionJornada: data?.fechaInicioJornadaReducida || data?.FechaInicioJornadaReducida || "",
                    PorcentajeReduccionJornada: data?.porcentajeReduccion ?? data?.PorcentajeReduccion ?? "",
                    EnfermedadesIds: toStringArray(data?.enfermedadesIds ?? data?.EnfermedadesIds ?? data?.enfermedadId ?? data?.EnfermedadId),
                    CodigosEnfermedad: toStringArray(data?.codigosEnfermedad ?? data?.CodigosEnfermedad ?? data?.codigoEnfermedad ?? data?.CodigoEnfermedad),
                },

                OtrosDatos: {
                    TipoVoluntarioIRPF: data?.retencionIRPF ?? data?.RetencionIRPF ?? "",
                    TipoIRPFAplica: (data?.tablatipo ?? data?.Tablatipo ?? "")?.toString?.() ?? "",
                    TablaGeneralHijos: data?.numeroHijos ?? data?.NumeroHijos ?? "",
                    TipoVoluntarioPorcentaje: data?.porcentajeVoluntario ?? data?.PorcentajeVoluntario ?? "",
                },

                DomicilioComunicaciones: {
                    Domicilio: data?.datosComunicacion_Domicilio || data?.DatosComunicacion_Domicilio || "",
                    Numero: data?.datosComunicacion_Numero || data?.DatosComunicacion_Numero || "",
                    Bloque: data?.datosComunicacion_Bloque || data?.DatosComunicacion_Bloque || "",
                    Escalera: data?.datosComunicacion_Escalera || data?.DatosComunicacion_Escalera || "",
                    Piso: data?.datosComunicacion_Piso || data?.DatosComunicacion_Piso || "",
                    Puerta: data?.datosComunicacion_Puerta || data?.DatosComunicacion_Puerta || "",
                    TelefonoContacto: data?.datosComunicacion_Telefono || data?.DatosComunicacion_Telefono || "",
                    CodigoPostal: data?.datosComunicacion_CodigoPostal || data?.DatosComunicacion_CodigoPostal || "",
                    Localidad: data?.datosComunicacion_Localidad || data?.DatosComunicacion_Localidad || "",
                    LocalidadDescripcion: data?.datosComunicacion_Localidad || data?.DatosComunicacion_Localidad || "",
                    Provincia: data?.datosComunicacion_Provincia || data?.DatosComunicacion_Provincia || "",
                    ProvinciaDescripcion: data?.datosComunicacion_Provincia || data?.DatosComunicacion_Provincia || "",
                    Pais: data?.datosComunicacion_Pais || data?.DatosComunicacion_Pais || "",
                    ApartadoCorreos: data?.datosComunicacion_ApartadoCorreos || data?.DatosComunicacion_ApartadoCorreos || "",
                },

                Alegaciones: data?.detalleAlegaciones || data?.DetalleAlegaciones || "",

                DatosBancarios: {
                    SolicitanteIBAN: (data?.iban || data?.IBAN || "").replace(/-/g, ''),
                },

                Documentacion: adaptDocumentacion(data?.SeccionesDocumentacion || null),
            })
        }

    }

    useEffect(() => {
        adaptApiResponseToDefaultValues(dataUser);
    }, [dataUser]);




    const onSubmit = async (data: any) => {
        console.log(data);
        setLoader(true);

        const parseNumber = (value: any) => {
            if (value === null || value === undefined || value === '') return 0;
            const normalized = String(value).replace(',', '.');
            const parsed = Number(normalized);
            return Number.isNaN(parsed) ? 0 : parsed;
        };

        const parseNullableInt = (value: any) => {
            if (value === null || value === undefined || value === '') return null;
            const parsed = Number.parseInt(String(value), 10);
            return Number.isNaN(parsed) ? null : parsed;
        };

        const formatDate = (value: any) => {
            if (!value) return null;
            if (value instanceof Date) return value.toISOString();
            return value;
        };

        const datosMenorPersistidos = Array.isArray(dataUser?.datosMenor)
            ? dataUser?.datosMenor
            : Array.isArray(dataUser?.DatosMenor)
                ? dataUser?.DatosMenor
                : [];

        const datosMenor = [0, 1]
            .map((index) => ({
                Id: datosMenorPersistidos?.[index]?.Id || datosMenorPersistidos?.[index]?.id || null,
                ExpedienteId: datosMenorPersistidos?.[index]?.ExpedienteId || datosMenorPersistidos?.[index]?.expedienteId || null,
                nombreApellidos: data?.DatosMenor?.[index]?.MenorNombre || '',
                ipf: data?.DatosMenor?.[index]?.MenorIPF || '',
                fechaNacimiento: formatDate(data?.DatosMenor?.[index]?.MenorFechaNacimiento),
            }))
            .filter((item) => item.nombreApellidos || item.ipf || item.fechaNacimiento);

        const userId = String(dataUser?.UsuarioId || datosAPI?.UsuarioId || '');
        const formId = String(dataUser?.Id || datosAPI?.Id || '');
        const otroProgenitorTrabajoTipo = parseNullableInt(data?.DatosOtroProgenitor?.TrabajaPorCuenta);
        const otroProgenitorRegimenTipoActividad =
            otroProgenitorTrabajoTipo === 0
                ? 0
                : parseNullableInt(data?.DatosOtroProgenitor?.TipoRegimen);
        const esAutonomo = normalizeRelacionLaboralBoolean(data?.DatosPersonales?.EsAutonomo);

        const datosEnvio = {
            Id: dataUser?.Id || null,
            ExternalId: dataUser?.ExternalId || 0,
            PersonaId: dataUser?.PersonaId || 0,
            UsuarioId: dataUser?.UsuarioId || null,
            ExpedienteId: dataUser?.ExpedienteId || null,
            PrestacionId: dataUser?.PrestacionId || null,
            Acepto: data?.Acepto ?? false,



            datosPersonales: {
                nombre: data?.DatosPersonales?.SolicitanteNombre || '',
                apellido1: data?.DatosPersonales?.SolicitanteApellido1 || '',
                apellido2: data?.DatosPersonales?.SolicitanteApellido2 || '',
                ipf: data?.DatosPersonales?.SolicitanteIPF || '',
                ipfTipo: parseInt(data?.DatosPersonales?.SolicitanteIPFTipo) || 1,
                telefono: data?.DatosPersonales?.SolicitanteTelefono || '',
                fijo: data?.DatosPersonales?.SolicitanteFijo || '',
                domicilio: data?.DatosPersonales?.SolicitanteDomicilio || '',
                codigoPostal: data?.DatosPersonales?.SolicitanteCodigoPostal || '',
                ProvinciaDescripcion: data?.DatosPersonales?.SolicitanteProvinciaDescripcion || null,
                CodigoProvincia: data?.DatosPersonales?.SolicitanteProvincia || null,

                CodigoLocalidad: data?.DatosPersonales?.SolicitanteComunidadCodigo || null,
                LocalidadDescripcion: data?.DatosPersonales?.SolicitanteComunidadCodigoDescripcion || null,
                numeroSeguridadSocial: data?.DatosPersonales?.SolicitanteNumeroSS || '',
            },
            Nacionalidad: data?.DatosPersonales?.SolicitanteNacionalidad || '',
            fechaNacimiento: formatDate(data?.DatosPersonales?.SolicitanteFechaNacimiento),
            empresaNombre: data?.DatosPersonales?.SolicitanteEmpresa || '',
            empresaCCC: esAutonomo === true ? null : data?.DatosPersonales?.SolicitanteCCC || '',
            EmpresaNombre: data?.DatosPersonales?.SolicitanteEmpresa || '',
            EmpresaCCC: esAutonomo === true ? null : data?.DatosPersonales?.SolicitanteCCC ?? null,
            CIF: esAutonomo === true ? null : data?.DatosPersonales?.SolicitanteCIF ?? null,
            NAF: esAutonomo === false ? null : data?.DatosPersonales?.SolicitanteNAF ?? null,
            EsAutonomo: esAutonomo,
            relacionMenor: parseNullableInt(data?.DatosPersonales?.RelacionConElMenor),
            email: data?.DatosPersonales?.CorreoElectronico || '',
            esFamiliaMonoparental: data?.DatosPersonales?.FamiliaMonoparental ?? false,

            otroProgenitor_Apellido1: data?.DatosOtroProgenitor?.OtroProgenitorApellido1 || '',
            otroProgenitor_Apellido2: data?.DatosOtroProgenitor?.OtroProgenitorApellido2 || '',
            otroProgenitor_Nombre: data?.DatosOtroProgenitor?.OtroProgenitorNombre || '',
            otroProgenitor_IPF: data?.DatosOtroProgenitor?.OtroProgenitorIPF || '',
            otroProgenitor_NumeroSeguridadSocial: data?.DatosOtroProgenitor?.OtroProgenitorNumeroSS || '',
            otroProgenitor_TrabajoTipo: otroProgenitorTrabajoTipo,
            otroProgenitor_RegimenTipoActividad: otroProgenitorRegimenTipoActividad,
            otroProgenitor_EmpresaNombre: data?.DatosOtroProgenitor?.Empresa || '',
            otroProgenitor_EmpresaCCC: data?.DatosOtroProgenitor?.CCC || '',
            otroProgenitor_RegimenEspecialNombre: data?.DatosOtroProgenitor?.RegimenEspecial || '',
            otroProgenitor_RegimenOtrosNombre: data?.DatosOtroProgenitor?.OtroRegimen || '',

            datosMenor,
            fechaIngresoMenor: formatDate(data?.MotivoSolicitud?.FechaIngreso),
            reducidaJornadaLaboral: data?.MotivoSolicitud?.ReduccionJornada ?? null,
            fechaInicioJornadaReducida: formatDate(data?.MotivoSolicitud?.FechaReduccionJornada),
            porcentajeReduccion: parseNumber(data?.MotivoSolicitud?.PorcentajeReduccionJornada),
            CodigosEnfermedad: toStringArray(data?.MotivoSolicitud?.CodigosEnfermedad),

            retencionIRPF: parseNumber(data?.OtrosDatos?.TipoVoluntarioIRPF),
            tablatipo: parseInt(data?.OtrosDatos?.TipoIRPFAplica) || 0,
            numeroHijos: parseInt(data?.OtrosDatos?.TablaGeneralHijos) || 0,
            porcentajeVoluntario: parseNumber(data?.OtrosDatos?.TipoVoluntarioPorcentaje),

            datosComunicacion_Domicilio: data?.DomicilioComunicaciones?.Domicilio || '',
            datosComunicacion_Numero: data?.DomicilioComunicaciones?.Numero || '',
            datosComunicacion_Bloque: data?.DomicilioComunicaciones?.Bloque || '',
            datosComunicacion_Escalera: data?.DomicilioComunicaciones?.Escalera || '',
            datosComunicacion_Piso: data?.DomicilioComunicaciones?.Piso || '',
            datosComunicacion_Puerta: data?.DomicilioComunicaciones?.Puerta || '',
            datosComunicacion_Telefono: data?.DomicilioComunicaciones?.TelefonoContacto || '',
            datosComunicacion_CodigoPostal: data?.DomicilioComunicaciones?.CodigoPostal || '',
            datosComunicacion_Localidad: data?.DomicilioComunicaciones?.Localidad || '',
            datosComunicacion_Provincia: data?.DomicilioComunicaciones?.Provincia || '',
            datosComunicacion_Pais: data?.DomicilioComunicaciones?.Pais || '',
            datosComunicacion_ApartadoCorreos: data?.DomicilioComunicaciones?.ApartadoCorreos || '',
            Documentacion: await prepareDocumentacionArrayWithCase(data?.Documentacion ?? data?.SeccionesDocumentacion ?? []),
            detalleAlegaciones: data?.Alegaciones || '',
            iban: data?.DatosBancarios?.SolicitanteIBAN
                ?.replace(/(.{4})(.{4})(.{4})(.{2})/, '$1-$2-$3-$4-') || '',
        };

        if (info) {
            await createPrestacionCUME(userId, datosEnvio, onSuccess);
            setBloquearEnvio(true);
        } else {
            await updatePrestacionCUMEById(userId, formId, datosEnvio, onSuccess);
            setBloquearEnvio(true);
        }


        setTimeout(() => {
            setLoader(false); //tiempo cargar DOM
        }, 500);
    };





    return (
        <FormProvider {...formMethods}>
            <div className="container form--simple-styled" id="formDeltawithoutleave">

                {/* ////////////// OBSERVACIONES DEL GESTOR A LA SOLICITUD ////////////// */}
                <FormObservaciones observaciones={datosAPI?.Observaciones} titulo={'Observaciones del Gestor a la Solicitud'} />

                <Loader activeLoader={loader || loadingCreatePrestacionCUME || loadingUpdatePrestacionCUMEById} label="Cargando Formulario"></Loader>

                {/* //////////////////////////// COMIENZO FORMULARIO //////////////////////////// */}
                {/* ////////////// DATOS DEL TRABAJADOR ////////////// */}
                <FormInfoCreateUpdate
                    isCreate={info}
                    estadoFormulario={datosAPI?.EstadoFormulario ?? datosAPI?.estadoFormulario ?? dataUser?.EstadoFormulario ?? dataUser?.estadoFormulario}
                    estadoFormularioDescripcion={datosAPI?.EstadoFormularioDescripcion ?? datosAPI?.estadoFormularioDescripcion ?? dataUser?.EstadoFormularioDescripcion ?? dataUser?.estadoFormularioDescripcion}
                    fechaActualizacionEstado={datosAPI?.FechaActualizacionEstado ?? datosAPI?.fechaActualizacionEstado ?? dataUser?.FechaActualizacionEstado ?? dataUser?.fechaActualizacionEstado}
                />
                <FormDatosPersonales activarSS={true} activarFechaNacimiento={true} emailVisible={false} activarNumerosDireccion={false} activarNacionalidad={true}  >
                    <FormInputEmail
                        name='DatosPersonales.CorreoElectronico'
                        id='DatosPersonales.CorreoElectronico'
                        label='Correo Electrónico'
                        md={12}
                        xl={12}
                        modal='A efectos de comunicación'
                        req='El correo electrónico es obligatorio'
                        disabled={false}
                    />
                    <FormRelacionesLaborales
                        info={info}
                        names={{
                            nombreEmpresa: 'DatosPersonales.SolicitanteEmpresa',
                            ccc: 'DatosPersonales.SolicitanteCCC',
                            naf: 'DatosPersonales.SolicitanteNAF',
                            cif: 'DatosPersonales.SolicitanteCIF',
                            esAutonomo: 'DatosPersonales.EsAutonomo',
                        }}
                        labels={{
                            selector: 'Selecciona un Entorno laboral',
                            nombreEmpresa: 'Nombre o Razón Social',
                            ccc: 'Código Cuenta Cotización',
                            naf: 'NAF',
                            cif: 'CIF',
                        }}
                        selectorName='DatosPersonales.RelacionLaboralId'
                        relacionesLaborales={datosAPI?.RelacionLaboral ?? datosAPI?.relacionLaboral ?? []}
                        md={6}
                        xl={6}
                    />
                    <FormInputRadioGroup
                        title="Relación con el Menor"
                        name="DatosPersonales.RelacionConElMenor"
                        required='Debe seleccionar una relación con el menor'
                        labels={[
                            "Progenitor",
                            "Acogedor preadoptivo/permanente",
                            "Adoptante",
                            "Tutor"
                        ]}
                        col={12}
                    />
                    <p className='fw-bold mt-2'>Datos de la unidad familiar</p>
                    <FormInputYesNo
                        name="DatosPersonales.FamiliaMonoparental"
                        title="Es familiar monoparental"
                        required='Debe contestar si la familia es monoparental'
                        modal='Familia monoparental: constituida por un progenitor con el que convive el menor y que es el sustentador único de la familia'
                    />


                </FormDatosPersonales>
                <AccordionForm title={'Datos identificativos del otro progenitor/adoptante/acogedor'} expandedInit={false} nombreError='DatosOtroProgenitor' >
                    <div className="row mb-4">
                        <div className="col-xl-12">


                            <FieldsetContainer legend="" disabled={false}>




                                <FormInputText
                                    name='DatosOtroProgenitor.OtroProgenitorNombre'
                                    id='DatosOtroProgenitor.OtroProgenitorNombre'
                                    label='Nombre'
                                    md={4}
                                    xl={4}

                                />
                                <FormInputText
                                    name='DatosOtroProgenitor.OtroProgenitorApellido1'
                                    id='DatosOtroProgenitor.OtroProgenitorApellido1'
                                    label='Primer Apellido'
                                    md={4}
                                    xl={4}

                                />
                                <FormInputText
                                    name='DatosOtroProgenitor.OtroProgenitorApellido2'
                                    id='DatosOtroProgenitor.OtroProgenitorApellido2'
                                    label='Segundo Apellido'
                                    md={4}
                                    xl={4}

                                />
                                <FormInputText
                                    name='DatosOtroProgenitor.OtroProgenitorIPF'
                                    id='DatosOtroProgenitor.OtroProgenitorIPF'
                                    label='DNI-NIE-Pasaporte'
                                    req={watch('DatosPersonales.FamiliaMonoparental') === false ? 'El DNI-NIE-Pasaporte del otro progenitor es obligatorio si la familia no es monoparental' : null}
                                    md={6}
                                    xl={6}

                                />
                                <FormInputText
                                    name='DatosOtroProgenitor.OtroProgenitorNumeroSS'
                                    id='DatosOtroProgenitor.OtroProgenitorNumeroSS'
                                    label='Numero de la Seguridad Social'
                                    md={6}
                                    xl={6}
                                    maxLength={12}
                                    pattern={/^[0-9]{1,12}$/}
                                    patternMessage='Solo se permiten números (máximo 12 dígitos)'
                                />
                                <FormInputRadioGroup
                                    title="Trabaja por cuenta:"
                                    name="DatosOtroProgenitor.TrabajaPorCuenta"

                                    labels={[
                                        "Ajena",
                                        "Propia",
                                    ]}
                                    col={12}
                                />
                                <AccordionDisplay dataUser={dataUser} visibility={watch('DatosOtroProgenitor.TrabajaPorCuenta') === '0'} fields={['DatosOtroProgenitor.Empresa', 'DatosOtroProgenitor.CCC', 'DatosOtroProgenitor.TipoRegimen', 'DatosOtroProgenitor.OtroRegimen', 'DatosOtroProgenitor.RegimenEspecial']}>
                                    <FormInputText
                                        name='DatosOtroProgenitor.Empresa'
                                        id='DatosOtroProgenitor.Empresa'
                                        label='Nombre de la Empresa'
                                        md={6}
                                        xl={6}
                                        req={watch('DatosOtroProgenitor.TrabajaPorCuenta') === '0' ? 'El nombre de la empresa del otro progenitor es obligatorio si trabaja por cuenta ajena' : null}
                                    />
                                    <FormInputText
                                        name='DatosOtroProgenitor.CCC'
                                        id='DatosOtroProgenitor.CCC'
                                        label='CCC de la Empresa'
                                        md={6}
                                        xl={6}
                                        pattern={/^[0-9]{11}$/}
                                        maxLength={11}
                                        patternMessage='Solo se permiten numeros enteros y máximo 11 dígitos'
                                        req={watch('DatosOtroProgenitor.TrabajaPorCuenta') === '0' ? 'El CCC de la empresa del otro progenitor es obligatorio si trabaja por cuenta ajena' : null}
                                    />
                                </AccordionDisplay>
                                <AccordionDisplay dataUser={dataUser} visibility={watch('DatosOtroProgenitor.TrabajaPorCuenta') === '1'} fields={['DatosOtroProgenitor.TipoRegimen', 'DatosOtroProgenitor.OtroRegimen', 'DatosOtroProgenitor.RegimenEspecial']}>
                                    <FormInputRadioGroup
                                        title="Pertenece en razón de su actividad al:"
                                        name="DatosOtroProgenitor.TipoRegimen"
                                        required={watch('DatosOtroProgenitor.TrabajaPorCuenta') === '1' ? 'Debe seleccionar el régimen al que pertenece el otro progenitor si trabaja por cuenta propia' : null}
                                        labels={[
                                            "Régimen Especial",
                                            "Otro Régimen",
                                        ]}
                                        values={[1, 2]}
                                        col={12}
                                    />
                                    <AccordionDisplay dataUser={dataUser} visibility={watch('DatosOtroProgenitor.TipoRegimen') === '1'} fields={['DatosOtroProgenitor.RegimenEspecial']}>
                                        <FormInputText
                                            name='DatosOtroProgenitor.RegimenEspecial'
                                            id='DatosOtroProgenitor.RegimenEspecial'
                                            label='Regimen Especial de: '
                                            md={12}
                                            xl={12}
                                            req={watch('DatosOtroProgenitor.TipoRegimen') === '1' ? 'El régimen especial al que pertenece el otro progenitor es obligatorio si trabaja por cuenta propia y pertenece a régimen especial' : null}
                                        />
                                    </AccordionDisplay>

                                    <AccordionDisplay dataUser={dataUser} visibility={watch('DatosOtroProgenitor.TipoRegimen') === '2'} fields={['DatosOtroProgenitor.OtroRegimen']}>
                                        <FormInputText
                                            name='DatosOtroProgenitor.OtroRegimen'
                                            id='DatosOtroProgenitor.OtroRegimen'
                                            label='Otros:  '
                                            md={12}
                                            xl={12}
                                            req={watch('DatosOtroProgenitor.TipoRegimen') === '2' ? 'Debe especificar el otro régimen al que pertenece el otro progenitor si trabaja por cuenta propia y pertenece a otro régimen' : null}
                                        />
                                    </AccordionDisplay>

                                </AccordionDisplay>



                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>


                <AccordionForm title={'Datos del Menor/es'} expandedInit={false} nombreError='DatosMenor' >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FieldsetContainer
                                legend="Datos del Menor/es"
                            >
                                <FormInputText
                                    name='DatosMenor.0.MenorNombre'
                                    id='DatosMenor.0.MenorNombre'
                                    label='Nombre y Apellidos'
                                    md={6}
                                    xl={6}
                                />
                                <FormInputText
                                    name='DatosMenor.0.MenorIPF'
                                    id='DatosMenor.0.MenorIPF'
                                    label='DNI-NIE-Pasaporte'
                                    md={3}
                                    xl={3}
                                />
                                <FormInputFecha
                                    name='DatosMenor.0.MenorFechaNacimiento'
                                    id='DatosMenor.0.MenorFechaNacimiento'
                                    label='Fecha de Nacimiento'
                                    md={3}
                                    xl={3}
                                />
                                <FormInputText
                                    name='DatosMenor.1.MenorNombre'
                                    id='DatosMenor.1.MenorNombre'
                                    label='Nombre y Apellidos'
                                    md={6}
                                    xl={6}
                                />
                                <FormInputText
                                    name='DatosMenor.1.MenorIPF'
                                    id='DatosMenor.1.MenorIPF'
                                    label='DNI-NIE-Pasaporte'
                                    md={3}
                                    xl={3}
                                />
                                <FormInputFecha
                                    name='DatosMenor.1.MenorFechaNacimiento'
                                    id='DatosMenor.1.MenorFechaNacimiento'
                                    label='Fecha de Nacimiento'
                                    md={3}
                                    xl={3}
                                />
                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>



                <AccordionForm title={'Motivo de la Solicitud'} expandedInit={false} nombreError='MotivoSolicitud' >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FieldsetContainer
                                legend="Motivo de la Solicitud"
                            >
                                <FormInputFecha
                                    name='MotivoSolicitud.FechaIngreso'
                                    id='MotivoSolicitud.FechaIngreso'
                                    label='Fecha del Ingreso hospitalario del menor'
                                    md={6}
                                    xl={6}
                                />

                                <FormInputYesNo
                                    name="MotivoSolicitud.ReduccionJornada"
                                    title="¿Reducción de Jornada Laboral?"
                                    label='¿Ha reducido la Jornada laboral?'
                                    col={6}
                                />
                                <AccordionDisplay dataUser={dataUser} visibility={watch('MotivoSolicitud.ReduccionJornada') === true} fields={['MotivoSolicitud.FechaReduccionJornada', 'MotivoSolicitud.PorcentajeReduccionJornada']}>
                                    <FormInputFecha
                                        name='MotivoSolicitud.FechaReduccionJornada'
                                        id='MotivoSolicitud.FechaReduccionJornada'
                                        label='Fecha de Inicio de la jornada reducida'
                                        req={watch('MotivoSolicitud.ReduccionJornada') === true ? 'La fecha de inicio de la jornada reducida es obligatoria' : undefined}
                                        md={6}
                                        xl={6}
                                    />
                                    <FormInputText
                                        name='MotivoSolicitud.PorcentajeReduccionJornada'
                                        id='MotivoSolicitud.PorcentajeReduccionJornada'
                                        label='Porcentaje de reducción (al menos del 50%)'
                                        req={watch('MotivoSolicitud.ReduccionJornada') === true ? 'El porcentaje de reducción de jornada es obligatorio' : undefined}
                                        md={6}
                                        xl={6}
                                        pattern={/^(100([.,]0{1,2})?|([5-9][0-9])([.,][0-9]{1,2})?)$/}
                                        patternMessage='Debe indicar un porcentaje entre 50 y 100 con hasta 2 decimales'
                                    />
                                </AccordionDisplay>
                                <div className="mb-3"></div>
                                <FormInputEnfermedadesCUME
                                    name='MotivoSolicitud.EnfermedadesIds'
                                    codeName='MotivoSolicitud.CodigosEnfermedad'
                                    required='Debe añadir al menos una enfermedad'
                                    md={12}
                                    xl={12}
                                />
                            </FieldsetContainer>

                        </div>
                    </div>
                </AccordionForm>


                <AccordionForm title={'Otros Datos'} expandedInit={false} nombreError='OtrosDatos' >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FieldsetContainer
                                legend="Datos Fiscales"
                            >
                                <p>
                                    Tipo voluntario de retención por IRPF
                                    <InputTextIntegration inputType={3} name={'OtrosDatos.TipoVoluntarioIRPF'} />%
                                    <br />
                                    Si su residencia fiscal está en <strong> TERRITORIO FORAL</strong>, a efectos de retención por IRPF desea que se le aplique:
                                </p>
                                <FormInputRadioGroup
                                    title=""
                                    name="OtrosDatos.TipoIRPFAplica"
                                    labels={[
                                        "Tabla General",
                                        "Tabla de Pensionistas",
                                        "Tipo Voluntario %"
                                    ]}
                                    col={12}
                                />
                                <AccordionDisplay dataUser={dataUser} visibility={watch('OtrosDatos.TipoIRPFAplica') === '0'} fields={['DatosOtroProgenitor.OtroRegimen']}>
                                    <FormInputText
                                        name='OtrosDatos.TablaGeneralHijos'
                                        id='OtrosDatos.TablaGeneralHijos'
                                        label='Número de Hijos:  '
                                        md={12}
                                        xl={12}
                                        pattern={/^[0-9]+$/}
                                        patternMessage='Debe poner solo numeros'
                                    />
                                </AccordionDisplay>
                                <AccordionDisplay dataUser={dataUser} visibility={watch('OtrosDatos.TipoIRPFAplica') === '2'} fields={['OtrosDatos.TipoVoluntarioPorcentaje']}>
                                    <FormInputText
                                        name='OtrosDatos.TipoVoluntarioPorcentaje'
                                        id='OtrosDatos.TipoVoluntarioPorcentaje'
                                        label='Tipo voluntario %:  '
                                        md={12}
                                        xl={12}
                                        pattern={/^[0-9]+([.,][0-9]{1,2})?$/}
                                        patternMessage='Debe poner solo numeros con un maximo de 2 decimales'
                                    />
                                </AccordionDisplay>
                            </FieldsetContainer>
                        </div>
                    </div>
                    <div className="row mb-4">
                        <div className="col-xl-12">

                            <FieldsetContainer
                                legend="Domicilio de comunicaciones a efectos legales"
                            >

                                {/* Domicilio completo */}
                                <p className='fw-bold mb-2'>
                                    (sólo si es distinto del indicado en el apartado 'DATOS PERSONALES')
                                </p>
                                <FormInputText
                                    name='DomicilioComunicaciones.Domicilio'
                                    id='DomicilioComunicaciones.Domicilio'
                                    label='Domicilio (calle/plaza/avenida...)'
                                    md={12}
                                    xl={12}
                                />


                                {/* Número, Bloque, Escalera, Piso, Puerta */}


                                <FormInputText
                                    name='DomicilioComunicaciones.Numero'
                                    id='DomicilioComunicaciones.Numero'
                                    label='Número'
                                    md={3}
                                    xl={3}
                                    pattern={/^[0-9]+$/}
                                    patternMessage='Solo números enteros'
                                />

                                <FormInputText
                                    name='DomicilioComunicaciones.Bloque'
                                    id='DomicilioComunicaciones.Bloque'
                                    label='Bloque'
                                    md={2}
                                    xl={2}
                                    pattern={/^[A-Za-z0-9]{0,10}$/}
                                    patternMessage='Solo letras y números'
                                />

                                <FormInputText
                                    name='DomicilioComunicaciones.Escalera'
                                    id='DomicilioComunicaciones.Escalera'
                                    label='Escalera'
                                    md={2}
                                    xl={2}
                                    pattern={/^[A-Za-z0-9]{0,10}$/}
                                    patternMessage='Solo letras y números'
                                />

                                <FormInputText
                                    name='DomicilioComunicaciones.Piso'
                                    id='DomicilioComunicaciones.Piso'
                                    label='Piso'
                                    md={2}
                                    xl={2}
                                    pattern={/^[0-9]+$/}
                                    patternMessage='Solo números enteros'
                                />

                                <FormInputText
                                    name='DomicilioComunicaciones.Puerta'
                                    id='DomicilioComunicaciones.Puerta'
                                    label='Puerta'
                                    md={3}
                                    xl={3}
                                    pattern={/^[A-Za-z0-9]{0,10}$/}
                                    patternMessage='Solo letras y números'
                                />



                                {/* Teléfono y Código Postal */}


                                <FormInputText
                                    name='DomicilioComunicaciones.TelefonoContacto'
                                    id='DomicilioComunicaciones.TelefonoContacto'
                                    label='Teléfono de contacto'
                                    md={6}
                                    xl={6}
                                    pattern={/^[0-9]{9}$/}
                                    patternMessage='Debe contener 9 dígitos'
                                />

                                <FormInputText
                                    name='DomicilioComunicaciones.CodigoPostal'
                                    id='DomicilioComunicaciones.CodigoPostal'
                                    label='Código postal'
                                    md={3}
                                    xl={3}
                                    pattern={/^[0-9]{5}$/}
                                    patternMessage='Debe contener 5 dígitos'
                                />

                                <FormInputText
                                    name='DomicilioComunicaciones.ApartadoCorreos'
                                    id='DomicilioComunicaciones.ApartadoCorreos'
                                    label='Apartado de correos'
                                    md={3}
                                    xl={3}

                                />


                                {/* País */}

                                <FormInputText
                                    name='DomicilioComunicaciones.Pais'
                                    id='DomicilioComunicaciones.Pais'
                                    label='País'
                                    md={4}
                                    xl={4}
                                />

                                <div className="col-xl-4 col-md-4">
                                    <Province
                                        errors={errors}
                                        register={register}
                                        idCode={'DomicilioComunicaciones.Provincia'}
                                        watchProvinceDescription={watchProvinciaDescCooperativa}
                                        idDescription={'DomicilioComunicaciones.ProvinciaDescripcion'}
                                        watchProvinceCode={watchProvinciaCooperativa}
                                        setValue={setValue}
                                        disabled={false}
                                    />
                                </div>
                                <div className="col-xl-4 col-md-4">
                                    <TestCommunity
                                        errors={errors}
                                        register={register}
                                        setValue={setValue}
                                        watchProvinceCode={watchProvinciaCooperativa}
                                        watchCommunityCode={watchCommCooperativa}
                                        watchCommunityDescription={watchCommDescCooperativa}
                                        idCode={'DomicilioComunicaciones.Localidad'}
                                        idDescription={'DomicilioComunicaciones.LocalidadDescripcion'}
                                        filterByProvince={true}
                                        disabled={false}
                                    />
                                </div>
                            </FieldsetContainer>

                        </div>
                    </div>
                </AccordionForm>



                <AccordionForm title={'Alegaciones'} expandedInit={false} nombreError='Alegaciones' >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FieldsetContainer
                                legend=""
                            >
                                <TextAreaDefault
                                    name='Alegaciones'
                                    id='Alegaciones'
                                    label='Alegaciones'
                                />
                                <div className='m-2'></div>
                            </FieldsetContainer>

                        </div>
                    </div>
                </AccordionForm>

                <AccordionForm title={'Datos Bancarios'} expandedInit={false} nombreError='DatosBancarios' >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FieldsetContainer legend="Datos Bancarios para el cobro de la prestación mediante transferencia bancaria" disabled={false}>

                                <FormInputCuentaBancaria
                                    id='DatosBancarios.SolicitanteIBAN'
                                    name='DatosBancarios.SolicitanteIBAN'
                                    xl={12}
                                    md={12}
                                    placeholder=''
                                    req='Falta el Número de Cuenta Bancaria' />
                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>

                <AccordionForm title={'Documentacion'} expandedInit={false} nombreError='Documentacion' totalSize={totalSize} maxSize={MAX_SIZE_MB} >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FormArrayArchivosReducidos
                                name={'Documentacion'}
                                urlArchivos={dataUser?.Documentacion?.map(d => d?.SasUri) || []}
                                setTotalSize={setTotalSize}
                            />

                        </div>
                    </div>
                </AccordionForm>



                {/* ////////////// FINAL FORMULARIO ////////////// */}


                {/* ////////////// BLOQUEO DEL ENVIO DEL FORMULARIO //////////// */}
                <FormBotonSubmit
                    disableSubmit={bloquearEnvio}
                    onSubmit={handleSubmit(onSubmit)}
                    successCreate={successCreatePrestacionCUME}
                    successUpdate={successUpdatePrestacionCUMEById}
                    errorCreate={errorCreatePrestacionCUME}
                    errorUpdate={errorUpdatePrestacionCUMEById}
                    datosAPI={datosAPI}
                    totalSizeDocs={totalSize}
                    info={info}
                    initExpand={!info}
                    MaxSizeMB={MAX_SIZE_MB}
                    infoLabel='INSTRUCCIONES PARA CUMPLIMENTAR LA SOLICITUD'
                    label='Declaro bajo mi responsabilidad, que son ciertos los datos que consigno en la presente solicitud, que suscribo para que se me reconozca la prestación económica por cuidado de menores afectados por cáncer u otra enfermedad grave, manifestando que quedo enterado/a de la obligación de comunicar cualquier variación de los mismos que pueda producirse mientras perciba la prestación.'
                >
                    <div className="container my-4">

                        <div className="mb-4">
                            <p className="fw-bold">1. DATOS PERSONALES DEL SOLICITANTE.-</p>
                            <p className="mb-2">
                                Este apartado se cumplimentará con los datos de identificación personal y de residencia permanente del solicitante.
                            </p>
                            <p className="ps-3 mb-0">
                                <span className="fw-bold">1.1 DATOS DE LA UNIDAD FAMILIAR.-</span>
                                Cumplimente la casilla correspondiente.
                            </p>
                        </div>

                        <div className="mb-4">
                            <p className="fw-bold">2. DATOS IDENTIFICATIVOS DEL OTRO PROGENITOR.-</p>
                            <p className="mb-0">
                                Si hay otro progenitor, cumplimente sus datos de identificación personal y laboral, indicando si pertenece al Sistema de la Seguridad Social.
                                De pertenecer a otro Sistema o Colegio Profesional, indíquelo.
                            </p>
                        </div>

                        <div className="mb-4">
                            <p className="fw-bold">3. DATOS DEL MENOR/ES.-</p>
                            <p className="mb-0">
                                Cumplimente los datos solicitados. Si el menor ha cumplido 14 años el dato DNI/NIE/Pasaporte es obligatorio.
                            </p>
                        </div>

                        <div className="mb-4">
                            <p className="fw-bold">4. MOTIVO DE LA SOLICITUD.-</p>
                            <p className="mb-0">
                                Cumplimente las casillas correspondientes y consigne las fechas y datos de que disponga.
                            </p>
                        </div>

                        <div className="mb-4">
                            <p className="fw-bold">5. OTROS DATOS</p>

                            <div className="ps-3 mb-3">
                                <p className="fw-bold mb-1">5.1 DATOS FISCALES.</p>
                                <p className="mb-0">
                                    Su declaración es totalmente voluntaria y en base a la misma se practicarán las retenciones sobre rendimiento del trabajo.
                                    Para ello ha de cumplimentar el modelo 145 de la Agencia Tributaria: Comunicación de datos al pagador,
                                    que debe presentar con esta solicitud. Además, puede solicitar tipo de retención voluntario por IRPF.
                                </p>
                            </div>

                            <div className="ps-3">
                                <p className="fw-bold mb-1">5.2 EL DOMICILIO DE COMUNICACIONES</p>
                                <p className="mb-0">
                                    A efectos legales sólo debe indicarse cuando desee recibirlas en otro distinto del cumplimentado en el apartado 1,
                                    incluidas las comunicaciones oficiales en las que se le pidan actuaciones en plazos determinados.
                                    Si desea que se le envíen a un apartado de correos también puede indicarlo.
                                </p>
                            </div>
                        </div>

                        <div className="mb-4">
                            <p className="fw-bold">6. ALEGACIONES.-</p>
                            <p className="mb-0">
                                Si quiere añadir algo que considere importante para tramitar su prestación y no vea recogido en esta solicitud,
                                póngalo en este apartado de la forma más breve y concisa posible.
                            </p>
                        </div>

                        <div className="mb-4">
                            <p className="fw-bold">7. DATOS BANCARIOS.-</p>
                            <p className="mb-0">
                                Ponga especial cuidado al rellenar las casillas para que no haya problemas cuando hagamos el ingreso.
                            </p>
                        </div>

                    </div>

                    <div className="mt-5 pt-4 border-top">

                        <div className="text-center mb-4">
                            <p className="fw-bold mb-0">DOCUMENTOS NECESARIOS PARA EL TRÁMITE DE LA PRESTACIÓN</p>
                        </div>

                        <div className="mb-4">
                            <p className="fw-bold">EN TODOS LOS CASOS</p>

                            <div className="ps-3">


                                <p><span className="fw-bold">1. </span>
                                    Acreditación de identidad de los interesados (también del causante si tiene 14 años) mediante fotocopia de la siguiente documentación en vigor:
                                </p>
                                <ul className="mb-3">
                                    <li>Españoles: Documento nacional de identidad (DNI).</li>
                                    <li>Extranjeros: Pasaporte o, en su caso, documento de identidad vigente en su país y NIE (Número de Identificación de Extranjero) exigido por la AEAT a efectos de pago.</li>
                                </ul>

                                <p className='mb-2'><span className="fw-bold">2.</span> Certificado de la empresa en el que consten las bases de cotización por contingencias profesionales así como el porcentaje de parcialidad en la reducción de jornada.</p>

                                <p><span className="fw-bold">3.</span> Documentación relativa a la cotización:</p>
                                <ul className="mb-3">
                                    <li>Para los Artistas y Profesionales Taurinos: Declaración de actividades y justificantes de actuaciones que no hayan sido presentadas en la Tesorería General de la Seguridad Social.</li>
                                    <li>Trabajadores responsables del ingreso de las cuotas: Justificantes del pago de los 3 últimos meses.</li>
                                </ul>

                                <p><span className="fw-bold">4.</span> Certificado del facultativo del Servicio Público de Salud en el que conste que el menor se encuentra afectado por cáncer u otra enfermedad grave que requiere ingreso hospitalario de larga duración, indicando la fecha estimada de duración del ingreso y si el menor precisa un tratamiento continuado de la enfermedad, fuera del centro hospitalario, que indique la duración estimada del mismo.</p>

                                <p><span className="fw-bold">5.</span> Fotocopia del Libro de familia o, en su defecto, certificado de la inscripción del hijo en el Registro Civil o resolución judicial de la adopción.</p>

                                <p><span className="fw-bold">6.</span> Resolución administrativa o judicial SOLO para los casos de acogimiento/tutela.</p>

                            </div>
                        </div>

                        <div className="mb-4">
                            <p className="fw-bold">SOLO EN EL CASO DE TRABAJADORES RESPONSABLES DEL INGRESO DE CUOTAS:</p>
                            <div className="ps-3">
                                <p><span className="fw-bold">7.</span> Declaración del porcentaje de parcialidad de la jornada de trabajo.</p>
                            </div>
                        </div>

                        <div>
                            <p className="fw-bold">OTROS DOCUMENTOS:</p>
                            <div className="ps-3">

                                <p><span className="fw-bold">8.</span> En el supuesto de no convivencia de los progenitores, y en ausencia de acuerdo sobre el que debe percibir la prestación, documentación que acredite la custodia o a cargo de quién está el menor.</p>

                                <p><span className="fw-bold">9.</span> En el caso de familias monoparentales: Fotocopia de Libro de familia en el que conste un solo progenitor o, en el caso de que consten dos progenitores, certificado de defunción de uno de ellos, o resolución judicial en la que se declare el abandono de familia de uno de ellos.</p>

                                <p className="mb-0">
                                    <span className="fw-bold">10.</span> Si el otro progenitor no pertenece al Sistema de la Seguridad Social debe aportar, en su caso:
                                </p>
                                <ul>
                                    <li>Certificado expedido por la unidad de personal de su centro de trabajo indicando que el mismo realiza una actividad laboral encuadrada en el Sistema de Clases Pasivas.</li>
                                    <li>Certificado del Colegio Profesional al que pertenezca, si se trata de una actividad profesional.</li>
                                </ul>

                            </div>
                        </div>

                    </div>

                </FormBotonSubmit>


                <p className='text-info-legal paragraph  text-secondary  mb-4'>
                    Esta solicitud va a ser tramitada por medios informáticos. Los datos personales que figuran en ella serán incorporados a un fichero de base de datos para el cálculo y control de la prestación económica
                    que se le reconozca, y permanecerán bajo custodia de esta Entidad. En cualquier momento puede ejercitar su derecho de acceso, rectificación, cancelación y oposición sobre los datos incorporados al
                    fichero ( art. 5 de la ley 15/1999 de 13 diciembre de Protección de datos de carácter personal, BOE del día 14)
                </p>

                <p className='text-info-legal paragraph  text-secondary  mb-4'>
                    En cumplimiento de lo establecido en la normativa sobre de Protección de Datos de Carácter Personal, Solimat Mutua Colaboradora con la Seguridad Social nº 72 le informa que sus datos de carácter
                    personal serán objeto de tratamiento, con la finalidad del mantenimiento y cumplimiento de la relación. La base jurídica que legitima el tratamiento de sus datos es el
                    cumplimiento de una obligación legal. Sus datos serán conservados de forma indefinida en nuestra entidad para atender a las posibles responsabilidades derivadas del tratamiento. Usted
                    podrá revocar el consentimiento prestado, así como ejercitar sus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento, o portabilidad, en su caso, remitiendo un
                    escrito a la siguiente dirección: Solimat, Mutua Colaboradora con la Seguridad Social nº 72, C/ Berna, 1, 45003, Toledo, adjuntando su NIF. Si considera que sus derechos no han sido
                    debidamente atendidos, puede contactar con nuestro delegado de protección de datos lopd@solimat.com o interponer una reclamación frente a la Agencia Española de Protección de Datos.
                </p>



            </div>
        </FormProvider>
    )
}

export default PrestacionCUME
